import React, { useState } from "react";
import * as Yup from "yup";
import { useAuth } from "../utility/auth";
import { Formik } from "formik";
import {
  Container,
  Grid,
  useTheme,
  Box,
  Stack,
  IconButton,
} from "@mui/material";
import Load from "../components/FormsUI/Loader/index";
import Controls from "../components/FormsUI";
import { downloadPDF } from "../utility/downloadPDF";
import MastersController from "../controller/MastersController";
import PDFSRC from "../assets/images/pdf_icon.png";
import SearchIcon from "@mui/icons-material/Search";
import PDFLoader from "../assets/images/loader.gif";
import DonationFeeController from "../controller/DonationFeeController";
import FeeReceiptController from "../controller/FeeReceiptController";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ExceptionHandlerController from "../controller/ErrorLogsController";
import "../css/style.css";
import dayjs from "dayjs";
import moment from "moment";
import CustomizedSnackbars from "../components/Alert";
import { tokens } from "../theme";
const numberRegEx = /^[0-9\b]+$/;
let panRegEx = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

let bankName = [];

const INITIAL_FORM_STATE = {
  donorType: "",
  donorName: "",
  donorPanNo: "",
  donationAmount: "",
  donorEmailId: "",
  donorContactNo: "",
  donorChequeDate: "",
  donorChequeNo: "",
  donationType: "",
  other: "",
  donorAddress: "",
  donationYear: "",
  donorCity: "",
  donorCountry: "",
  bankCodeId: "",
  donationDate: "",
  donationUTR: "",
  donationMode: "",
  instrumentalNumber: "",
  selectedDonationType: null,
  selectedDonationMode: null,
  selectedDonorType: null,
  donationYearSelected: null,
};

const customDateValidation = (message, field) =>
  Yup.string().test("custom-validation", message, function (value) {
    let errorMessage = "";
    if (!value) {
      errorMessage = message;
      return this.createError({ path: field, message: errorMessage });
    }
    let dateRegEx = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegEx.test(value)) {
      errorMessage = "Invalid date";
      return this.createError({ path: field, message: errorMessage });
    }
    let date = value?.split("/");
    if (date[0] === "Invalid date") {
      errorMessage = "Invalid date";
      return this.createError({ path: field, message: errorMessage });
    }
    let formattedDate = new Date(
      Number(date[2]),
      Number(date[1] - 1),
      Number(date[0])
    );
    if (formattedDate > new Date()) {
      errorMessage = "Future dates are not allowed";
      return this.createError({ path: field, message: errorMessage });
    }

    return true;
  });

const FORM_VALIDATION = Yup.object({
  bankCodeId: Yup.string()
    .optional()
    .trim("No white space allowed")
    .strict(true),
  donorType: Yup.string().required("Donor type is required"),
  donationAmount: Yup.string()
    .required("Donation amount is required")
    .trim("No white space allowed")
    .strict(true)
    .matches(/^\d{1,7}(\.\d{1,2})?$/, "Invalid amount exceed"),
  donationYear: Yup.string()
    .required("Donation year is required")
    .trim("No white space allowed")
    .strict(true),
  donorEmailId: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .test("is-valid-emails", "Invalid Email-id(s)", function (value) {
      if (!value) return true; // optional field

      const emails = value.split(",").map(email => email.trim());
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      const allValid = emails.every(email => emailRegex.test(email));
      return allValid;
    }),
  donorContactNo: Yup.string()
    .trim("No white space allowed")

    .max(12, "12 Digit number allowed")
    .optional()

    .strict(true),
  donorChequeNo: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .optional(),
  donorChequeDate: Yup.string()
    .optional()
    .trim("No white space allowed")
    .strict(true),
  donationDate: customDateValidation(
    "Receipt date is required",
    "donationDate"
  ),
  donationMode: Yup.string().optional(),
  donationType: Yup.string().required("Donation type is required"),
  donationUTR: Yup.string()
    .optional()
    .trim("No white space allowed")
    .strict(true),
  donorAddress: Yup.string()
    .optional()
    .trim("No white space allowed")
    .strict(true),
  donorCity: Yup.string().when("donorAddress", {
    is: (donorAddress) => donorAddress && donorAddress.trim() !== "",
    then: Yup.string()
      .required("Donor city is required")
      .trim("No white space allowed")
      .strict(true),
    otherwise: Yup.string()
      .optional()
      .trim("No white space allowed")
      .strict(true),
  }),
  donorCountry: Yup.string().when("donorAddress", {
    is: (donorAddress) => donorAddress && donorAddress.trim() !== "",
    then: Yup.string()
      .required("Donor country is required")
      .trim("No white space allowed")
      .strict(true),
    otherwise: Yup.string()
      .optional()
      .trim("No white space allowed")
      .strict(true),
  }),
  donorName: Yup.string()
    .required("Donor name is required")
    .trim("No white space allowed")
    .matches(
      /^[A-Z a-z]+$/,
      "Donor Name  must contain only alphabetic characters"
    )
    .strict(true),
  donorPanNo: Yup.string()
    .matches(
      /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      "Invalid PAN format. Example: ABCDE1234F"
    )
    .optional()
    .trim("No white space allowed")
    .strict(true),
  instrumentalNumber: Yup.string()
    .optional()
    .trim("No white space allowed")
    .strict(true),
  other: Yup.string().when("donationType", {
    is: (value) => value === process.env.REACT_APP_DONATION_OTHER_ID,
    then: Yup.string()
      .required("Others field is required")
      .max(150, "Others must not exceed 150 characters")
      .trim("No white space allowed")
      .strict(true),
    otherwise: Yup.string()
      .optional()
      .trim("No white space allowed")
      .strict(true),
  }),
});

const DonationComponent = () => {
  const mastersController = new MastersController();
  const donationFeeController = new DonationFeeController();
  const exceptionHandlerController = new ExceptionHandlerController();
  const feeReceiptController = new FeeReceiptController();

  const theme = useTheme();
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const { data, token } = user;
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const [receiptGrid, setReceiptGrid] = useState([]);
  const [feeYearDD, setYearFeeDD] = useState();
  const [pdfData, setPdfData] = useState(false);
  const [donationIdValue, setDonationValueId] = useState("");
  const [emailPDFSending, setEmailPDFSending] = useState(false);
  const [file, setFile] = useState({ pdf: "" });
  const [bankValue, setBankValue] = useState(null);
  const [pdfFileName, setPdfFileName] = useState("");
  const [mastersValue, setMastersValue] = useState({
    bankMastersData: [],
    donationTypeData: [],
    donorTypeData: [],
  });
  const [donorTypeDD, setDonorTypeDD] = useState(null);
  const [donorTypeValue, setDonorTypeValue] = useState(null);
  const [memberNameDD, setMemberNameDD] = useState(null);
  const [disableDonationYear, setDisableDonationYear] = useState(false);
  const [donationTypeValue, setDonationTypeValue] = useState(null);
  const [memberList, setMemberList] = useState([]);
  const [isDropdown, setIsDropdown] = useState(false);
  const [donationModeData, setDonationModeData] = useState(null);
  const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
  const [feeYearData, setFeeYearData] = useState(null);
  const [emailData, setEmailData] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(true);
  const [donationTypeDD, setDonationTypeDD] = useState();
  // const { userid: tenantId } = data.UserInfo;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const colors = tokens(theme.palette.mode);
  const [popup, setPopUp] = useState(false);
  const [popup1, setPopUp1] = useState(false);
  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };
  const [numberMinMax, setNumberMinMax] = useState({
    donationAmount: "",
    donorContactNo: "",
  });
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  React.useEffect(() => {
    getDonationGrid();
    getBankMasters();
    getDonationType();
    getDonorType();
    getMastersFeeYear("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getMastersFeeYear = (feeYearId) => {
    let caughtError;
    try {
      mastersController
        .GetMastersFeeYear()
        .then((resultObj) => {
          if (resultObj.status === 200) {
            const result = resultObj?.data?.body;
            const fetchedFeeData = result.map((item) => ({
              label: item?.year,
              value: item?._id,
            }));
            setYearFeeDD(fetchedFeeData);
            if (feeYearId) {
              const fetchedResponseFee = result.filter(
                (item) => item._id === feeYearId
              );
              const { year, _id } = fetchedResponseFee[0];
              const filteredObject = { label: year, value: _id };
              setFeeYearData(filteredObject);
            }
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }
        })
        .catch((error) => {
          caughtError = error;
          let logData = {};
          logData.message = caughtError?.message;
          logData.stack = caughtError?.stack;
          let logError = {
            logData,
            module: "feeReceipt getMastersFeeYear inside method",
          };
          exceptionHandlerController.HandleException(logError);
        });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "feeReceipt getMastersFeeYear method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const getDonationType = () => {
    let caughtError;
    try {
      mastersController
        .GetDonationType()
        .then((resultObj) => {
          setLoader(() => false);
          if (resultObj.status === 200) {
            const result = resultObj?.data?.body;
            setMastersValue((prevState) => ({
              ...prevState,
              donationTypeData: result,
            }));
            const fetchedFeeData = result.map((item) => ({
              label: item?.donation,
              value: item?._id,
            }));
            setDonationTypeDD(fetchedFeeData);
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }
        })
        .catch((error) => {
          caughtError = error;
          let logData = {};
          logData.message = caughtError?.message;
          logData.stack = caughtError?.stack;
          let logError = {
            logData,
            module: "donation.jsx getDonationType inside method",
          };
          exceptionHandlerController.HandleException(logError);
        });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "feeReceipt getDonationType method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const handleDonorNameChangeDD = (event, value, setFieldValue) => {
    if (value && value?.value) {
      setFieldValue("memberNameId", value.value);
      setFieldValue("donorName", value.label);
      // setFieldValue("selectedDonorType", value);
      handleMemberList(value.value);
    } else {
      setFieldValue("donorName", event.target.value);
    }
  };

  const handleDonationDateChange = (e, setFieldTouched, setFieldValue) => {
    setFieldTouched("donationDate", true);
    const formattedDate = moment(new Date(e)).format("DD/MM/YYYY");
    setFieldValue("donationDate", formattedDate);
  };

  const handleSendPDFMail = () => {
    setEmailPDFSending(true);
    if (emailData) {
      sendPDFMail();
    }
  };

  const handlePDFDownload = () => {
    const fileName = `${pdfFileName}.pdf`;
    downloadPDF({
      file: file?.pdf,
      showAlert,
      fileName,
    });
  };

  const handleDonationAmountChange = (event, setFieldValue) => {
    const { value } = event?.target;

    if (value) {
      if (numberRegEx.test(value)) {
        setNumberMinMax((prev) => ({
          ...prev,
          donationAmount: value,
        }));
        setFieldValue("donationAmount", value);
      }
    } else {
      setFieldValue("donationAmount", "");
    }
  };

  const handleSearchClick = (value) => {
    const donorName = value.donorName;
    if (donorName) {
      handleMemberData(donorName);
    } else {
      showAlert("error", "Please input the member name field");
    }
  };

  const handleEmailChange = (e, setFieldValue) => {
    const { value } = e.target;
    setFieldValue("donorEmailId", value);
    // setEmailData(value && emailRegex.test(value));
  };

  const handleChequeDateChange = (e, setFieldTouched, setFieldValue) => {
    setFieldTouched("donorChequeDate", true);
    const formattedDate = moment(new Date(e)).format("DD/MM/YYYY");
    setFieldValue("donorChequeDate", formattedDate);
  };

  const getBankMasters = () => {
    let caughtError;
    try {
      //fetching bank masters for dropdown options
      mastersController
        .GetMastersBank()
        .then((result) => {
          setLoader(() => false);
          if (result?.status === 200) {
            setMastersValue((prevState) => ({
              ...prevState,
              bankMastersData: result?.data?.body,
            }));
            if (bankName?.length === 0)
              result?.data?.body?.map((item) => {
                return bankName?.push({
                  label: item?.bankName,
                  value: item?.bankID,
                });
              });
          } else {
            showAlert("error", "something went wrong kindly refresh");
          }
        })
        .catch((error) => {
          caughtError = error;
          let logData = {};
          logData.message = caughtError?.message;
          logData.stack = caughtError?.stack;
          let logError = { logData, module: "DonationComponent page Get method" };
          exceptionHandlerController.HandleException(logError);
        });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "donation.jsx details page Get method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const DonationModeDD = [
    { label: "Cash", value: "Cash" },
    { label: "Cheque", value: "Cheque" },
    { label: "Online", value: "Online" },
  ];

  const handleContactNumberChange = (event, setFieldValue) => {
    const { value } = event?.target;

    if (value) {
      if (numberRegEx.test(value)) {
        setNumberMinMax((prev) => ({
          ...prev,
          donorContactNo: value,
        }));
        setFieldValue("donorContactNo", value);
      }
    } else {
      setFieldValue("donorContactNo", "");
    }
  };

  const handleDonorNameChange = (setFieldValue, event) => {
    const newValue = event?.target?.value;
    setFieldValue("donorName", newValue);
  };

  const getDonorType = () => {
    let caughtError;
    try {
      mastersController
        .GetDonorType()
        .then((result) => {
          if (result?.status === 200) {
            setMastersValue((prevState) => ({
              ...prevState,
              donorTypeData: result?.data?.body,
            }));
            setLoader(() => false);
            const donorName = [];
            result?.data?.body?.map((item) => {
              return donorName?.push({
                label: item?.donorType,
                value: item?._id,
              });
            });
            setDonorTypeDD(donorName);
          } else {
            showAlert("error", "something went wrong kindly refresh");
            setLoader(() => false);
          }
        })
        .catch((error) => {
          caughtError = error;
          let logData = {};
          logData.message = caughtError?.message;
          logData.stack = caughtError?.stack;
          let logError = { logData, module: "DonationComponent page Get Donor method" };
          exceptionHandlerController.HandleException(logError);
        });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: "donation.jsx page Get getDonorType" };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const setUpdatedValuesIds = (updatedData) => {
    const { bankCodeId, donationTypeId, donorTypeId } = updatedData;
    const filterAndSetValue = (array, id, labelKey, valueKey, setValueFn) => {
      if (id) {
        const fetchedResponse = array.filter((item) => item[valueKey] === id);
        if (fetchedResponse.length > 0) {
          const filteredObject = {
            label: fetchedResponse[0][labelKey],
            value: fetchedResponse[0][valueKey],
          };
          setValueFn(filteredObject);
        }
      }
    };
    filterAndSetValue(
      mastersValue.bankMastersData,
      bankCodeId,
      "bankName",
      "bankID",
      setBankValue
    );
    filterAndSetValue(
      mastersValue.donationTypeData,
      donationTypeId,
      "donation",
      "_id",
      setDonationTypeValue
    );
    filterAndSetValue(
      mastersValue.donorTypeData,
      donorTypeId,
      "donorType",
      "_id",
      setDonorTypeValue
    );
  };

  const resetState = () => {
    setAlert({ counter: 0, type: "", msg: "" });
    setUpdatedValues(INITIAL_FORM_STATE);
    setDonationModeData(null);
    setFeeYearData(null);
    setDonationTypeValue(null);
    setLoader(true);
    setIsDropdown(false);
    setDonationValueId("");
    setFile({ pdf: "" });
    setNumberMinMax({
      donationAmount: "",
      donorContactNo: "",
    });
  };

  const columns = [
    { headerName: "Id", field: "donationId", hide: true, filterable: false },
    { headerName: "Donor Name", field: "donorName", width: 180 },
    { headerName: "Donor Pan No", field: "donorPanNo", width: 150 },
    { headerName: "Amount", field: "donationAmount", width: 100 },
    { headerName: "Receipt No", field: "receiptNo", width: 150 },
    {
      headerName: "Receipt Date",
      field: "donationDate",
      width: 150,
      type: "date",
      valueGetter: (params) => {
        if (!params.value) return null;

        // Convert MM/DD/YYYY to DD/MM/YYYY format
        const dateObj = new Date(params.value);
        const day = dateObj.getDate().toString().padStart(2, "0");
        const month = (dateObj.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based
        const year = dateObj.getFullYear();

        return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
      },
      sortComparator: (date1, date2) => {
        const [d1, m1, y1] = date1.split("/").map(Number);
        const [d2, m2, y2] = date2.split("/").map(Number);
        return y1 - y2 || m1 - m2 || d1 - d2; // Sorts by Year -> Month -> Day
      },
    },
    { headerName: "Status", field: "status", width: 100 },
    {
      headerName: "Create Date",
      field: "createdDate",
      width: 150,
      type: "date",
      valueGetter: (params) => {
        if (!params.value) return null;

        // Convert MM/DD/YYYY to DD/MM/YYYY format
        const dateObj = new Date(params.value);
        const day = dateObj.getDate().toString().padStart(2, "0");
        const month = (dateObj.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based
        const year = dateObj.getFullYear();

        return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
      },
      sortComparator: (date1, date2) => {
        const [d1, m1, y1] = date1.split("/").map(Number);
        const [d2, m2, y2] = date2.split("/").map(Number);
        return y1 - y2 || m1 - m2 || d1 - d2; // Sorts by Year -> Month -> Day
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      sortable: false,
      disableExport: true,
      filterable: false,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        const onClick = (e, type) => {
          try {
            resetState();
            setPdfData(false);
            const currentRow = params.row;
            if (type === "Edit") {
              handleEdit(currentRow.id);
            } else {
              handleDelete(currentRow.id);
            }
          } catch (error) {
            handleError(error);
          }
        };

        const handleEdit = (id) => {
          donationFeeController
            .GetDonationById(id, token)
            .then(handleEditResponse)
            .catch((error) =>
              showAlert("error", error?.response?.data?.message)
            )
            .finally(() => setLoader(false));
        };

        const handleEditResponse = (resultObj) => {
          const responseData = resultObj?.data?.body ?? {};
          if (resultObj.status === 200) {
            if (responseData?.PDF) {
              setPdfData(true);
              fetch(responseData?.PDF)
                .then((res) => res?.blob())
                .then((blob) => setFile((prev) => ({ ...prev, pdf: blob })));
            }
            setDonationData(responseData);
            fetchPDF(responseData.PDF);
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }
        };

        const setDonationData = (responseDonation) => {
          const {
            donorType,
            donationDate,
            donationType,
            donationUTR,
            donorAddress,
            donorChequeDate,
            donorChequeNo,
            donorCity,
            donorCountry,
            donorEmailId,
            donorName,
            donorPanNo,
            instrumentalNumber,
            other,
            bankCodeId,
            donationMode,
            donationAmount,
            donorContactNo,
            donationId,
            donationYear,
          } = responseDonation;

          const tempData = {
            donorType,
            donationDate,
            donationType,
            donationUTR,
            donorAddress,
            donorChequeDate,
            donorChequeNo,
            donorCity,
            donorCountry,
            donorEmailId,
            donationAmount,
            donorContactNo,
            donorName,
            donorPanNo,
            bankCodeId: String(bankCodeId),
            donationMode,
            instrumentalNumber,
            other,
            donationYear,
          };

          setEmailData((donorEmailId && emailRegex.test(donorEmailId)) || donorContactNo);
          setPdfFileName(responseDonation?.setPdfName);
          setDonationValueId(donationId);
          setUpdatedValuesIds({
            donorTypeId: donorType,
            donationTypeId: donationType,
            bankCodeId,
          });
          setNumberMinMax((prev) => ({
            ...prev,
            donationAmount,
            donorContactNo,
          }));

          if (donationYear) {
            getMastersFeeYear(donationYear);
          }
          if (donationMode) {
            setDonationModeData({
              label: donationMode,
              value: donationMode,
            });
          }
          setUpdatedValues(tempData);
          handleData();
        };
        const fetchPDF = (pdfUrl) => {
          fetch(pdfUrl)
            .then((res) => res.blob())
            .then((blob) => setFile((prev) => ({ ...prev, pdf: blob })))
            .catch((error) => showAlert("error", "Failed to fetch PDF"));
        };

        const handleDelete = (id) => {
          donationFeeController
            .DeleteDonationDataById(id, token)
            .then((resultObj) => {
              if (resultObj.status === 200) {
                showAlert("success", "Deleted successfully");
                getDonationGrid();
              } else {
                showAlert("error", resultObj?.response?.data?.message);
              }
            })
            .catch((error) =>
              showAlert("error", error?.response?.data?.message)
            );
        };

        const handleError = (error) => {
          const logData = {
            message: error?.message,
            stack: error?.stack,
          };
          const logError = {
            logData,
            module: "service page onClick(Edit) method",
          };
          exceptionHandlerController.HandleException(logError);
        };

        return (
          <Stack direction="row" spacing={1}>
            <>
              <IconButton>
                <EditIcon
                  type="button"
                  color="primary"
                  id="Edit"
                  onClick={(e) => onClick(e, "Edit")}
                />
              </IconButton>
              <IconButton>
                <DeleteIcon
                  type="button"
                  color="primary"
                  id="Delete"
                  onClick={(e) => onClick(e, "Delete")}
                />
              </IconButton>
            </>
          </Stack>
        );
      },
    },
  ];

  const handleMemberList = (id) => {
    setUpdatedValues();
    setDonationValueId();
    let caughtError;
    try {
      const memberdata = memberList.filter(
        (value) => id === value?.memberId
      )[0];
      const tempData = {
        donorName: memberdata?.memberFullName ?? "",
        donorAddress: memberdata?.address ?? "",
        donorCity: memberdata?.city ?? "",
        donorCountry: memberdata?.country ?? "",
      };
      setUpdatedValues(tempData);
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = { logData, module: "feeReceipt handleMemberList method" };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const handleMemberData = async (value) => {
    setMemberNameDD([]);
    setIsDropdown(false);
    try {
      const resultObj = await feeReceiptController.GetMemberData(value, token);
      if (resultObj.status === 200) {
        const donorNames = resultObj?.data?.body ?? [];
        setMemberList(donorNames);

        const fetchedFamilyNameDD = donorNames
          .filter((item) => item && item.memberFullName && item.memberId) // Filter out invalid entries
          .map((item) => ({
            label: item.memberFullName,
            value: item.memberId,
          }));

        setMemberNameDD(fetchedFamilyNameDD);
        setIsDropdown(true);
        return { success: true, data: fetchedFamilyNameDD }; // Return a uniform response
      } else {
        showAlert("error", resultObj?.response?.data?.message);
        return { success: false, message: resultObj?.response?.data?.message }; // Return error message
      }
    } catch (error) {
      let logData = {
        message: error?.message,
        stack: error?.stack,
      };
      let logError = { logData, module: "feeReceipt handleMemberData method" };
      exceptionHandlerController.HandleException(logError);

      return { success: false, message: "An unexpected error occurred." }; // Return uniform error
    }
  };

  const sendPDFMail = () => {
    let caughtError;
    try {
      const id = donationIdValue;
      donationFeeController.SendPDFMail(id, token).then((response) => {
        setEmailPDFSending(false);
        if (response.status === 200) {
          getDonationGrid();
          showAlert("success", response?.data?.message);
        } else {
          showAlert("error", response?.response?.data?.message);
        }
      });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "feeReceipt page sendPDFMail method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const submitValues = (values) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    let caughtError;
    const filteredData = {};
    for (let key in values) {
      if (
        values[key] !== "" &&
        !key.startsWith(":") &&
        typeof values[key] !== "object" &&
        values[key] !== null &&
        !key.includes("option")
      ) {
        filteredData[key] = String(values[key]);
      }
    }
    if (donationIdValue) {
      filteredData.donationId = donationIdValue;
    }
    if (!(filteredData?.donorPanNo && panRegEx.test(filteredData.donorPanNo))) {
      setIsSubmitting(false);
      return showAlert("error", "Pan required or Invalid pan");
    }
    try {
      filteredData.tenantId = tenantId;
      donationFeeController
        .CreateDonation(filteredData, token)
        .then((resultObj) => {
          setEmailData(false);
          setIsSubmitting(false);
          if (resultObj.status === 201) {
            setDisableDonationYear(true);
            const serverResponse = resultObj?.data?.body;
            setDonationValueId(serverResponse?.result1?._id);
            setPdfFileName(serverResponse?.result1?.setPdfName);
            if (serverResponse?.PDF) {
              setPdfData(true);
              fetch(serverResponse?.PDF)
                .then((res) => res?.blob())
                .then((blob) => setFile((prev) => ({ ...prev, pdf: blob })));
            }
            if (serverResponse?.result1?.donorEmailId || serverResponse?.result1?.donorContactNo) {
              setEmailData(true);
            }
            getDonationGrid();

            showAlert("success", resultObj?.data?.message);
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }
        });
    } catch (error) {
      setIsSubmitting(false);
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "donation.jsx page submitValues method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const handlePopup = (value) => setPopUp(value);
  const handleData = () => setPopUp(true);
  const handlePopup1 = (value) => {
    setPopUp1(value);
    setDisableDonationYear(false);
  }
  const handleData1 = () => setPopUp1(true);

  const getDonationGrid = () => {
    let caughtError;
    try {
      donationFeeController
        .GetGridData(token)
        .then((resultObj) => {
          setLoader(() => false);
          if (resultObj.status === 200) {
            const userData = resultObj?.data?.body?.map((item) => {
              const { donationId: id, ...rest } = item;
              return { id, ...rest };
            });
            setReceiptGrid(() => userData);
          } else {
            showAlert("error", resultObj?.response?.data?.message);
          }
        })
        .catch((error) => {
          caughtError = error;
          let logData = {};
          logData.message = caughtError?.message;
          logData.stack = caughtError?.stack;
          let logError = {
            logData,
            module: "feeReceipt page getDonationGrid inside method",
          };
          exceptionHandlerController.HandleException(logError);
        });
    } catch (error) {
      caughtError = error;
      let logData = {};
      logData.message = caughtError?.message;
      logData.stack = caughtError?.stack;
      let logError = {
        logData,
        module: "feeReceipt page getDonationGrid method",
      };
      exceptionHandlerController.HandleException(logError);
    }
  };

  const AddDonation = (e) => {
    setIsDropdown(false);
    setPdfData(false);
    setDonationTypeValue(null);
    setFeeYearData(null);
    setDonorTypeValue(null);
    setDonationValueId("");
    setUpdatedValues();
    setDonationModeData(null);
    setNumberMinMax({
      donationAmount: "",
      donorContactNo: "",
    });
    handleData1();
  };
  if (loader) return <Load />;
  return (
    <Box
      sx={{
        "& .formBg": {
          border: `1px solid ${colors.grey[900]}`,
          background: `${colors.primary[400]}`,
        },
        "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
        "& .MuiGrid-root.Mui-heading h2": {
          color: `${colors.primary[200]} !important`,
        },
      }}
    >
      <Grid container>
        <Grid className="breadcrumb-section">
          <Grid className="breadcrumb-container">
            <Grid className="Mui-li">
              <nav className="Mui-nav" aria-label="breadcrumb">
                <ol className="">
                  <li className="MuiBreadcrumbs-li">
                    <h6 className="breadsub">Membership</h6>
                  </li>
                  <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                    /
                  </li>
                  <li className="MuiBreadcrumbs-li">
                    <h6>Donation</h6>
                  </li>
                </ol>
              </nav>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={12} className="adduser au1 pt-2">
          <Controls.ActionButton onClick={AddDonation}>
            Donation Receipt
          </Controls.ActionButton>
        </Grid>
        <Grid item xs={12} className="formBg">
          <Container maxWidth="md" className="formClwidth">
            <div>
              <Controls.Grid
                columns={columns}
                data={receiptGrid}
                fileName={"Generate Donation Receipt"}
              />

              {popup1 && (
                <Controls.Popup
                  title="Generate Donation Receipt"
                  minHeight={100}
                  openPopup={popup1}
                  setOpenPopup={handlePopup1}
                >
                  <Container maxWidth="md" className="formClwidth">
                    <div>
                      <Formik
                        enableReinitialize
                        initialValues={{
                          ...(updatedValues || INITIAL_FORM_STATE),
                        }}
                        validationSchema={FORM_VALIDATION}
                        onSubmit={(values) => submitValues(values)}
                      >
                        {({
                          values,
                          setFieldValue,
                          handleChange,
                          setFieldTouched,
                        }) => (
                          <React.Fragment>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={5}>
                                {isDropdown ? (
                                  <Controls.AutoComplete
                                    name="donorName"
                                    label={
                                      <span>
                                        Donor name{" "}
                                        <span className="asterisk">*</span>
                                      </span>
                                    }
                                    options={memberNameDD || null}
                                    type="string"
                                    // value={values?.donorName} // Bind the value to the form field
                                    onChange={(event, newValue) => {
                                      setFieldValue(
                                        "donorName",
                                        newValue?.value
                                      ); // Update the field when an option is selected
                                      handleDonorNameChangeDD(
                                        event,
                                        newValue,
                                        setFieldValue
                                      ); // Your custom handler logic
                                    }}
                                    onInputChange={(event, newInputValue) => {
                                      setFieldValue("donorName", newInputValue); // Update the field value as user types
                                    }}
                                  />
                                ) : (
                                  <Controls.Textfield
                                    name="donorName"
                                    label={
                                      <span>
                                        Donor name{" "}
                                        <span className="asterisk">*</span>
                                      </span>
                                    }
                                    onChange={(event) => {
                                      handleDonorNameChange(
                                        setFieldValue,
                                        event
                                      );
                                    }}
                                  />
                                )}
                              </Grid>
                              <Grid item xs={12} md={1}>
                                <SearchIcon
                                  className="btn-save"
                                  onClick={(event) => {
                                    handleSearchClick(values);
                                    handleChange(event);
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="donorType"
                                  label={
                                    <span>
                                      Donor type{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  options={donorTypeDD}
                                  getOptionLabel={(option) =>
                                    option?.label || ""
                                  }
                                  value={donorTypeValue || null} // Bind current value or null
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue("donorType", value?.value);
                                      setFieldValue("selectedDonorType", value);
                                      setDonorTypeValue(value); // Update local state
                                    } else {
                                      // Clear the fields if no value is selected
                                      setFieldValue("donorType", "");
                                      setFieldValue("selectedDonorType", null);
                                      setDonorTypeValue(null);
                                    }
                                    handleChange(event);
                                  }}
                                  onBlur={(event) => {
                                    const matchedOption = donorTypeDD.find(
                                      (option) =>
                                        option.label === event.target.value
                                    );
                                    if (matchedOption) {
                                      setFieldValue(
                                        "donorType",
                                        matchedOption.value
                                      );
                                      setFieldValue(
                                        "selectedDonorType",
                                        matchedOption
                                      );
                                      setDonorTypeValue(matchedOption);
                                    } else {
                                      // Clear fields if input doesn't match any option
                                      setFieldValue("donorType", "");
                                      setFieldValue("selectedDonorType", null);
                                      setDonorTypeValue(null);
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.value}>
                                      {option.label}
                                    </li>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="donationYear"
                                  label={
                                    <span>
                                      Donation year{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  options={feeYearDD}
                                  disabled={disableDonationYear}
                                  getOptionLabel={(option) =>
                                    option?.label || ""
                                  }
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue(
                                        "donationYear",
                                        value?.value
                                      );
                                      setFieldValue(
                                        "donationYearSelected",
                                        value
                                      );
                                      setFeeYearData(value);
                                    }
                                    handleChange(event);
                                  }}
                                  onBlur={(event) => {
                                    const matchedOption = feeYearDD.find(
                                      (option) =>
                                        option.label === event.target.value
                                    );
                                    if (matchedOption) {
                                      setFieldValue(
                                        "donationYear",
                                        matchedOption.value
                                      );
                                      setFieldValue(
                                        "donationYearSelected",
                                        matchedOption
                                      );
                                      setFeeYearData(matchedOption);
                                    } else {
                                      // Clear fields if input doesn't match any option
                                      setFieldValue("donationYear", "");
                                      setFieldValue(
                                        "donationYearSelected",
                                        null
                                      );
                                      setFeeYearData(null);
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.value}>
                                      {option.label}
                                    </li>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="donationType"
                                  label={
                                    <span>
                                      Donation type{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  options={donationTypeDD}
                                  getOptionLabel={(option) =>
                                    option?.label || ""
                                  }
                                  value={donationTypeValue} // Bind the current selected value
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue(
                                        "donationType",
                                        value?.value
                                      );
                                      setFieldValue(
                                        "selectedDonationType",
                                        value
                                      );
                                      setDonationTypeValue(value); // Update local state
                                    } else {
                                      // Clear the fields when no value is selected
                                      setFieldValue("donationType", "");
                                      setFieldValue(
                                        "selectedDonationType",
                                        null
                                      );
                                      setDonationTypeValue(null);
                                    }
                                    handleChange(event);
                                  }}
                                  onBlur={(event) => {
                                    const matchedOption = donationTypeDD.find(
                                      (option) =>
                                        option.label === event.target.value
                                    );
                                    if (matchedOption) {
                                      setFieldValue(
                                        "donationType",
                                        matchedOption.value
                                      );
                                      setFieldValue(
                                        "selectedDonationType",
                                        matchedOption
                                      );
                                      setDonationTypeValue(matchedOption);
                                    } else {
                                      // Clear the state if input doesn't match any option
                                      setFieldValue("donationType", "");
                                      setFieldValue(
                                        "selectedDonationType",
                                        null
                                      );
                                      setDonationTypeValue(null);
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.value}>
                                      {option.label}
                                    </li>
                                  )}
                                />
                              </Grid>

                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorPanNo"
                                  label={
                                    <span>
                                      Donor pan no{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  inputProps={{ maxLength: 10 }}
                                  onChange={(event) => {
                                    const { value } = event.target;
                                    if (value) {
                                      setFieldValue(
                                        "donorPanNo",
                                        value?.toUpperCase()
                                      );
                                    } else {
                                      setFieldValue("donorPanNo", "");
                                    }
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorEmailId"
                                  label={"Email-id"}
                                  type="string"
                                  inputProps={{ maxLength: 150 }}
                                  onChange={(e) =>
                                    handleEmailChange(e, setFieldValue)
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorContactNo"
                                  label={"Contact no"}
                                  type="string"
                                  inputProps={{ maxLength: 12 }}
                                  onChange={(event) =>
                                    handleContactNumberChange(
                                      event,
                                      setFieldValue
                                    )
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.DateTimePicker
                                  name="donationDate"
                                  label={
                                    <span>
                                      Receipt date{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  disableFuture={true}
                                  value={
                                    values?.donationDate
                                      ? dayjs(
                                        values?.donationDate,
                                        "DD/MM/YYYY"
                                      )
                                      : null
                                  }
                                  onChange={(e) =>
                                    handleDonationDateChange(
                                      e,
                                      setFieldTouched,
                                      setFieldValue
                                    )
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorChequeNo"
                                  label={"Cheque no"}
                                  type="string"
                                  inputProps={{ maxLength: 14 }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.DateTimePicker
                                  name="donorChequeDate"
                                  label="Cheque date"
                                  type="string"
                                  disableFuture={true}
                                  value={
                                    values?.donorChequeDate
                                      ? dayjs(
                                        values?.donorChequeDate,
                                        "DD/MM/YYYY"
                                      )
                                      : null
                                  }
                                  onChange={(e) =>
                                    handleChequeDateChange(
                                      e,
                                      setFieldTouched,
                                      setFieldValue
                                    )
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donationAmount"
                                  label={
                                    <span>
                                      Donation amount{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  value={numberMinMax.donationAmount}
                                  onChange={(e) =>
                                    handleDonationAmountChange(e, setFieldValue)
                                  }
                                />
                              </Grid>

                              {values?.donationType ===
                                process.env.REACT_APP_DONATION_OTHER_ID && (
                                  <Grid item xs={12} md={12}>
                                    <Controls.Textfield
                                      name="other"
                                      label={`Others${values?.donationType ===
                                        process.env.REACT_APP_DONATION_OTHER_ID
                                        ? " *"
                                        : ""
                                        }`}
                                      type="string"
                                      inputProps={{ maxLength: 150 }}
                                    />
                                  </Grid>
                                )}
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorAddress"
                                  label="Address"
                                  type="string"
                                  value={values?.donorAddress || ""}
                                  inputProps={{ maxLength: 150 }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorCity"
                                  label={`Donor city${values?.donorAddress !== "" ? " *" : ""
                                    }`}
                                  type="string"
                                  value={values?.donorCity || ""}
                                  inputProps={{ maxLength: 100 }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorCountry"
                                  label={`Donor country${values?.donorAddress !== "" ? " *" : ""
                                    }`}
                                  type="string"
                                  value={values?.donorCountry || ""}
                                  inputProps={{ maxLength: 100 }}
                                />
                              </Grid>

                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  id="bankCodeId"
                                  name="bankCodeId"
                                  options={bankName}
                                  label="Bank name"
                                  getOptionLabel={(option) =>
                                    option?.label || ""
                                  }
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue(
                                        "bankCodeId",
                                        String(value?.value || "")
                                      );
                                    }
                                  }}
                                  onBlur={(event) => {
                                    const selectedOption = bankName.find(
                                      (option) =>
                                        option.label === event.target.value
                                    );
                                    if (selectedOption) {
                                      setFieldValue(
                                        "bankCodeId",
                                        String(selectedOption?.value)
                                      );
                                    } else {
                                      setFieldValue("bankCodeId", ""); // Clear if invalid input
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.value}>
                                      {option.label}
                                    </li>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="donationMode"
                                  label="Donation mode"
                                  type="string"
                                  options={DonationModeDD}
                                  getOptionLabel={(option) =>
                                    option?.label || ""
                                  }
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue(
                                        "donationMode",
                                        value.value
                                      );
                                      setFieldValue(
                                        "selectedDonationMode",
                                        value
                                      );
                                      setDonationModeData(value);
                                    }
                                  }}
                                  onBlur={(event) => {
                                    const selectedOption = DonationModeDD.find(
                                      (option) =>
                                        option.label === event.target.value
                                    );
                                    if (selectedOption) {
                                      setFieldValue(
                                        "donationMode",
                                        selectedOption.value
                                      );
                                      setFieldValue(
                                        "selectedDonationMode",
                                        selectedOption
                                      );
                                    } else {
                                      setFieldValue("donationMode", ""); // Clear if invalid input
                                      setFieldValue(
                                        "selectedDonationMode",
                                        null
                                      );
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.value}>
                                      {option.label}
                                    </li>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="instrumentalNumber"
                                  label="Instrumental number"
                                  type="string"
                                  inputProps={{ maxLength: 100 }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donationUTR"
                                  label="Donation UTR"
                                  type="string"
                                  inputProps={{ maxLength: 100 }}
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <Grid item xs={4} md={2} className="marginAuto">
                                  {isSubmitting ? (
                                    <img
                                      src={PDFLoader}
                                      width={57}
                                      alt="Loading"
                                      style={{ marginLeft: "7px" }}
                                    />
                                  ) : (
                                    <Controls.Button >Submit</Controls.Button>
                                  )}
                                </Grid>
                              </Grid>
                              {pdfData && (
                                <>
                                  <Grid item xs={12} md={3}>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                                    <a onClick={handlePDFDownload}>
                                      <img
                                        src={PDFSRC}
                                        width={40}
                                        alt="pdf"
                                        style={{
                                          marginLeft: "17px",
                                          cursor: "pointer",
                                        }}
                                      />
                                      <span
                                        className="esigntext"
                                        style={{ display: "flex" }}
                                      >
                                        Download PDF
                                      </span>
                                    </a>
                                  </Grid>

                                  <Grid item xs={12} md={3}>
                                    {!emailPDFSending ? (
                                      <>
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a
                                          onClick={handleSendPDFMail}
                                          style={{
                                            cursor: emailData
                                              ? "pointer"
                                              : "not-allowed",
                                            pointerEvents: emailData
                                              ? "auto"
                                              : "none",
                                            opacity: emailData ? 1 : 0.5,
                                          }}
                                        >
                                          <img
                                            src={PDFSRC}
                                            width={37}
                                            alt="pdf"
                                            style={{ marginLeft: "7px" }}
                                          />
                                          <span
                                            className="esigntext"
                                            style={{ display: "flex" }}
                                          >
                                            Send PDF
                                          </span>
                                        </a>
                                      </>
                                    ) : (
                                      <>
                                        <img
                                          src={PDFLoader}
                                          width={57}
                                          alt="pdf"
                                          style={{ marginLeft: "7px" }}
                                        />
                                        <span
                                          className="esigntext"
                                          style={{ display: "flex" }}
                                        >
                                          Sending PDF
                                        </span>
                                      </>
                                    )}
                                  </Grid>
                                </>
                              )}
                            </Grid>
                          </React.Fragment>
                        )}
                      </Formik>
                    </div>
                  </Container>
                </Controls.Popup>
              )}

              {popup && (
                <Controls.Popup
                  title="Edit Donation Receipt"
                  minHeight={100}
                  openPopup={popup}
                  setOpenPopup={handlePopup}
                >
                  <Container maxWidth="md" className="formClwidth">
                    <div>
                      <Formik
                        enableReinitialize
                        initialValues={{
                          ...(updatedValues || INITIAL_FORM_STATE),
                        }}
                        validationSchema={FORM_VALIDATION}
                        onSubmit={(values) => submitValues(values)}
                      >
                        {({
                          values,
                          setFieldValue,
                          handleChange,
                          setFieldTouched,
                        }) => (
                          <React.Fragment>
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorName"
                                  label={
                                    <span>
                                      Donor name{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  onChange={(event) =>
                                    handleDonorNameChange(setFieldValue, event)
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="donorType"
                                  label={
                                    <span>
                                      Donor type{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  value={donorTypeValue}
                                  options={donorTypeDD}
                                  getOptionLabel={(option) =>
                                    option?.label || ""
                                  }
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue("donorType", value?.value);
                                      setFieldValue("selectedDonorType", value);
                                      setDonorTypeValue(value); // Update local state
                                    } else {
                                      // Clear fields if no value is selected
                                      setFieldValue("donorType", "");
                                      setFieldValue("selectedDonorType", null);
                                      setDonorTypeValue(null);
                                    }
                                    handleChange(event);
                                  }}
                                  onBlur={(event) => {
                                    const matchedOption = donorTypeDD.find(
                                      (option) =>
                                        option.label === event.target.value
                                    );
                                    if (matchedOption) {
                                      setFieldValue(
                                        "donorType",
                                        matchedOption.value
                                      );
                                      setFieldValue(
                                        "selectedDonorType",
                                        matchedOption
                                      );
                                      setDonorTypeValue(matchedOption);
                                    } else {
                                      // Clear state if input doesn't match any option
                                      setFieldValue("donorType", "");
                                      setFieldValue("selectedDonorType", null);
                                      setDonorTypeValue(null);
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.value}>
                                      {option.label}
                                    </li>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="donationYear"
                                  label={
                                    <span>
                                      Donation year{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  disabled={true}
                                  value={feeYearData}
                                  options={feeYearDD}
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue(
                                        "donationYear",
                                        value?.value
                                      );
                                      setFieldValue(
                                        "donationYearSelected",
                                        value
                                      );
                                      setFeeYearData(value);
                                    }
                                    handleChange(event);
                                  }}
                                  onBlur={(event) => {
                                    const matchedOption = feeYearDD.find(
                                      (option) =>
                                        option.label === event.target.value
                                    );
                                    if (matchedOption) {
                                      setFieldValue(
                                        "donationYear",
                                        matchedOption.value
                                      );
                                      setFieldValue(
                                        "donationYearSelected",
                                        matchedOption
                                      );
                                      setFeeYearData(matchedOption);
                                    } else {
                                      // Clear fields if input doesn't match any option
                                      setFieldValue("donationYear", "");
                                      setFieldValue(
                                        "donationYearSelected",
                                        null
                                      );
                                      setFeeYearData(null);
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.value}>
                                      {option.label}
                                    </li>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="donationType"
                                  label={
                                    <span>
                                      Donation type{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  value={donationTypeValue}
                                  options={donationTypeDD}
                                  getOptionLabel={(option) =>
                                    option?.label || ""
                                  }
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue(
                                        "donationType",
                                        value?.value
                                      );
                                      setFieldValue(
                                        "selectedDonationType",
                                        value
                                      );
                                      setDonationTypeValue(value);
                                    } else {
                                      // Clear fields if no value is selected
                                      setFieldValue("donationType", "");
                                      setFieldValue(
                                        "selectedDonationType",
                                        null
                                      );
                                      setDonationTypeValue(null);
                                    }
                                    handleChange(event);
                                  }}
                                  onBlur={(event) => {
                                    const selectedOption = donationTypeDD.find(
                                      (option) =>
                                        option.label === event.target.value
                                    );
                                    if (selectedOption) {
                                      setFieldValue(
                                        "donationType",
                                        selectedOption.value
                                      );
                                      setFieldValue(
                                        "selectedDonationType",
                                        selectedOption
                                      );
                                      setDonationTypeValue(selectedOption);
                                    } else {
                                      setFieldValue("donationType", "");
                                      setFieldValue(
                                        "selectedDonationType",
                                        null
                                      );
                                      setDonationTypeValue(null);
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.value}>
                                      {option.label}
                                    </li>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorPanNo"
                                  label={
                                    <span>
                                      Donor pan no{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  value={values?.donorPanNo}
                                  inputProps={{ maxLength: 10 }}
                                  onChange={(event) => {
                                    const { value } = event.target;
                                    setFieldValue(
                                      "donorPanNo",
                                      value?.toUpperCase()
                                    );
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorEmailId"
                                  label={"Email-id"}
                                  type="string"
                                  inputProps={{ maxLength: 150 }}
                                  onChange={(e) =>
                                    handleEmailChange(e, setFieldValue)
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorContactNo"
                                  label={"Contact no"}
                                  type="string"
                                  inputProps={{ maxLength: 12 }}
                                  onChange={(event) =>
                                    handleContactNumberChange(
                                      event,
                                      setFieldValue
                                    )
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.DateTimePicker
                                  name="donationDate"
                                  label={
                                    <span>
                                      Receipt date{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  disableFuture={true}
                                  value={
                                    values?.donationDate
                                      ? dayjs(
                                        values?.donationDate,
                                        "DD/MM/YYYY"
                                      )
                                      : null
                                  }
                                  onChange={(e) =>
                                    handleDonationDateChange(
                                      e,
                                      setFieldTouched,
                                      setFieldValue
                                    )
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorChequeNo"
                                  label="Cheque no"
                                  type="string"
                                  inputProps={{ maxLength: 14 }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.DateTimePicker
                                  name="donorChequeDate"
                                  type="string"
                                  label={`Cheque date${values?.donorChequeNo !== "" ? " *" : ""
                                    }`}
                                  disableFuture={true}
                                  value={
                                    values?.donorChequeDate
                                      ? dayjs(
                                        values?.donorChequeDate,
                                        "DD/MM/YYYY"
                                      )
                                      : null
                                  }
                                  onChange={(e) =>
                                    handleChequeDateChange(
                                      e,
                                      setFieldTouched,
                                      setFieldValue
                                    )
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donationAmount"
                                  label={
                                    <span>
                                      Donation amount{" "}
                                      <span className="asterisk">*</span>
                                    </span>
                                  }
                                  type="string"
                                  onChange={(e) =>
                                    handleDonationAmountChange(e, setFieldValue)
                                  }
                                />
                              </Grid>

                              {values?.donationType ===
                                process.env.REACT_APP_DONATION_OTHER_ID && (
                                  <Grid item xs={12} md={12}>
                                    <Controls.Textfield
                                      name="other"
                                      label={`${values?.donationType ===
                                        process.env
                                          .REACT_APP_DONATION_OTHER_ID ? (
                                        <span>
                                          Others{" "}
                                          <span className="asterisk">*</span>
                                        </span>
                                      ) : (
                                        "Others"
                                      )
                                        }`}
                                      type="string"
                                      inputProps={{ maxLength: 150 }}
                                    />
                                  </Grid>
                                )}
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorAddress"
                                  label="Address"
                                  type="string"
                                  value={values?.donorAddress || ""}
                                  inputProps={{ maxLength: 150 }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorCity"
                                  label={`Donor city${values?.donorAddress !== "" ? " *" : ""
                                    }`}
                                  type="string"
                                  value={values?.donorCity || ""}
                                  inputProps={{ maxLength: 100 }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donorCountry"
                                  label={`Donor country${values?.donorAddress !== "" ? " *" : ""
                                    }`}
                                  type="string"
                                  value={values?.donorCountry || ""}
                                  inputProps={{ maxLength: 100 }}
                                />
                              </Grid>

                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  id="bankCodeId"
                                  name="bankCodeId"
                                  options={bankName}
                                  value={bankValue}
                                  label="Bank name"
                                  getOptionLabel={(option) =>
                                    option?.label || ""
                                  }
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue(
                                        "bankCodeId",
                                        String(value?.value || "")
                                      );
                                      setBankValue(value);
                                    }
                                  }}
                                  onBlur={(event) => {
                                    const selectedOption = bankName.find(
                                      (option) =>
                                        option.label === event.target.value
                                    );
                                    if (selectedOption) {
                                      setFieldValue(
                                        "bankCodeId",
                                        String(selectedOption?.value)
                                      );
                                      setBankValue(selectedOption);
                                    } else {
                                      setFieldValue("bankCodeId", ""); // Clear if invalid input
                                      setBankValue(null);
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.value}>
                                      {option.label}
                                    </li>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.AutoComplete
                                  name="donationMode"
                                  label="Donation mode"
                                  type="string"
                                  value={donationModeData || ""}
                                  options={DonationModeDD}
                                  getOptionLabel={(option) =>
                                    option?.label || ""
                                  }
                                  onChange={(event, value) => {
                                    if (value) {
                                      setFieldValue(
                                        "donationMode",
                                        value.value
                                      );
                                      setFieldValue(
                                        "selectedDonationMode",
                                        value
                                      );
                                      setDonationModeData(value);
                                    } else {
                                      setFieldValue("donationMode", "");
                                      setFieldValue(
                                        "selectedDonationMode",
                                        null
                                      );
                                    }
                                  }}
                                  onBlur={(event) => {
                                    const selectedOption = DonationModeDD.find(
                                      (option) =>
                                        option.label === event.target.value
                                    );
                                    if (selectedOption) {
                                      setFieldValue(
                                        "donationMode",
                                        selectedOption.value
                                      );
                                      setFieldValue(
                                        "selectedDonationMode",
                                        selectedOption
                                      );
                                    } else {
                                      setFieldValue("donationMode", ""); // Clear if invalid input
                                      setFieldValue(
                                        "selectedDonationMode",
                                        null
                                      );
                                    }
                                  }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.value}>
                                      {option.label}
                                    </li>
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="instrumentalNumber"
                                  label="Instrumental number"
                                  type="string"
                                  inputProps={{ maxLength: 100 }}
                                />
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <Controls.Textfield
                                  name="donationUTR"
                                  label="Donation UTR"
                                  type="string"
                                  inputProps={{ maxLength: 100 }}
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <Grid item xs={4} md={2} className="marginAuto">
                                  {isSubmitting ? (
                                    <img
                                      src={PDFLoader}
                                      width={57}
                                      alt="Loading"
                                      style={{ marginLeft: "7px" }}
                                    />
                                  ) : (
                                    <Controls.Button >Submit</Controls.Button>
                                  )}
                                </Grid>
                              </Grid>

                              {pdfData && (
                                <>
                                  <Grid item xs={12} md={3}>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                                    <a onClick={handlePDFDownload}>
                                      <img
                                        src={PDFSRC}
                                        width={40}
                                        alt="pdf"
                                        style={{
                                          marginLeft: "17px",
                                          cursor: "pointer",
                                        }}
                                      />
                                      <span
                                        className="esigntext"
                                        style={{ display: "flex" }}
                                      >
                                        Download PDF
                                      </span>
                                    </a>
                                  </Grid>

                                  <Grid item xs={12} md={3}>
                                    {!emailPDFSending ? (
                                      <>
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                                        <a
                                          onClick={handleSendPDFMail}
                                          style={{
                                            cursor: emailData
                                              ? "pointer"
                                              : "not-allowed",
                                            pointerEvents: emailData
                                              ? "auto"
                                              : "none",
                                            opacity: emailData ? 1 : 0.5,
                                          }}
                                        >
                                          <img
                                            src={PDFSRC}
                                            width={37}
                                            alt="pdf"
                                            style={{ marginLeft: "7px" }}
                                          />
                                          <span
                                            className="esigntext"
                                            style={{ display: "flex" }}
                                          >
                                            Send PDF
                                          </span>
                                        </a>
                                      </>
                                    ) : (
                                      <>
                                        <img
                                          src={PDFLoader}
                                          width={57}
                                          alt="pdf"
                                          style={{ marginLeft: "7px" }}
                                        />
                                        <span
                                          className="esigntext"
                                          style={{ display: "flex" }}
                                        >
                                          Sending PDF
                                        </span>
                                      </>
                                    )}
                                  </Grid>
                                </>
                              )}
                            </Grid>
                          </React.Fragment>
                        )}
                      </Formik>
                    </div>
                  </Container>
                </Controls.Popup>
              )}

              {file?.pdfUrl && pdfData?.showIframe && (
                <iframe
                  src={file?.pdfUrl}
                  title="PDF Viewer"
                  width="100%"
                  height="500px"
                  style={{ border: "none", marginTop: "20px" }}
                ></iframe>
              )}
            </div>
          </Container>
        </Grid>
      </Grid>
      {alert.counter > 0 && (
        <CustomizedSnackbars
          status={alert.counter}
          msg={alert.msg}
          type={alert.type}
        />
      )}
    </Box>
  );
};

export default DonationComponent;
